const splideSettings = {
  arrows: true,
  drag: 'free',
  autoWidth: true,
  perMove: 8,
  gap: 24,
  pagination: false,
  wheel: true,
  omitEnd: true,
  waitForTransition: true,

  breakpoints: {
    768: {
      padding: {
        left: 16,
        right: 16,
      },
      wheel: false,
      waitForTransition: false,
    },

    1024: {
      gap: 8,
    },

    4000: {
      perMove: 12,
    },
  },
};

const selectors = {
  track: '[data-vehicle-type-sub-nav-track]',
  slide: '[data-vehicle-type-sub-nav-slide]',
  leftFade: '[data-vehicle-type-sub-nav-fade="left"]',
  rightFade: '[data-vehicle-type-sub-nav-fade="right"]',
};

const classes = {
  hide: 'hide',
};

export { classes, selectors, splideSettings };
